import { lazy } from 'react';

const LiteBranchUpgradePage = lazy(() => import('./LiteBranchUpgradePage'));

const LiteBranchUpgradeConfig = {
  settings: {
    layout: {
      config: {
        navbar: { display: false },
        topBanner: { display: false },
        healtheraHeader: { display: false },
        toolbar: { display: false },
        footer: { display: false },
        leftSidePanel: { display: false },
        rightSidePanel: { display: false },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'lite-upgrade',
      element: <LiteBranchUpgradePage />,
    },
  ],
};

export default LiteBranchUpgradeConfig;
